import { createConsoleApp } from '@console/core/createConsoleApp';
import { CONSOLE_PRODUCTS } from '@console/types';
import App from './App.vue';
import routes from './routes';
import './setup';

export default createConsoleApp(routes, App, CONSOLE_PRODUCTS.ALL_SERVICES);
